import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalFormAddRealisationPresta from "../ModalFormAddRealisationPresta";
import { fetchProfilPrestataire } from "../../redux/actions/profilActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import EditOverlay from "../EditOverlay";
import PhotoItem from "../PhotoItem";

const GestionRealisationsPresta = () => {
    const { prestataire } = useSelector((state) => state.profil);
    const token = useSelector((state) => state.auth.token);
    const apiUrl = process.env.REACT_APP_API_URL;
    const dispatch = useDispatch();

    const [showFormAddRea, setShowFormRea] = useState(false);
    const [realisations, setRealisations] = useState([...prestataire.realisations]);
    const [index, setIndex] = useState(0);
    const [editingRea, setEditingRea] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const urlImgPhotosRea = apiUrl + "/api/files/?categorie=realisations&file=";

    const refreshRealisations = () => {
        dispatch(fetchProfilPrestataire(token));
    };
    useEffect(() => {
        setRealisations(prestataire.realisations);

        // Si l'index courant dépasse la longueur du tableau après maj, on le ramène au max
        setIndex((prevIndex) => {
            const maxIndex = prestataire.realisations.length - 1;
            if (prevIndex === null || prevIndex < 0) return 0;
            return prevIndex > maxIndex ? maxIndex : prevIndex;
        });
    }, [prestataire.realisations]);
    useEffect(() => {
        // vide d'abord pour éviter l'affichage des anciennes images
        setSelectedImages([]);

        if (realisations.length > 0) {
            const currentRea = realisations[index];

            const existingPhotos = currentRea.photosRealisation.map((p) => ({
                file: null, // pas de File réel
                url: p.file ? p.preview : urlImgPhotosRea + p.photoName,
                idPhotoRealisation: p.idPhotoRealisation,
            }));

            // léger délai pour simuler le chargement (optionnel)
            setTimeout(() => setSelectedImages(existingPhotos), 50);
        }
    }, [index, realisations]);




    /* ------------------ API -------------------- */
    const updateRealisationField = async (reaId, titre, description) => {
        const formData = new FormData();
        formData.append("idRealisation", reaId);
        formData.append("titreRealisation", titre);
        formData.append("descriptionRealisation", description);

        try {
            const res = await fetch(`${apiUrl}/api/updateProfil/updateRealisationPrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });
            const data = await res.json();
            if (data.success) refreshRealisations();
            else alert(data.error || "Erreur lors de la mise à jour de la réalisation.");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la mise à jour de la réalisation.");
        }
    };

    const deleteRealisation = async (reaId) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cette réalisation ?")) return;
        const formData = new FormData();
        formData.append("idRealisation", reaId);

        try {
            const res = await fetch(`${apiUrl}/api/updateProfil/deleteRealisationPrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });
            const data = await res.json();
            if (data.success) refreshRealisations();
            else alert(data.error || "Erreur lors de la suppression.");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la suppression de la réalisation.");
        }
    };

    /**
     * Envoie plusieurs fichiers sélectionnés pour une réalisation existante.
     * - Compatible avec endpoint "addPhotoRealisation" qui attend un champ "photo" (on envoie une requête par fichier).
     * - Si ton backend accepte un upload multiple directement (photos[]), tu peux ajuster pour envoyer tous dans une seule FormData.
     */
    const addPhotos = async (reaId, files) => {
        if (!files || files.length === 0) return;

        // normaliser FileList -> Array
        const fileArray = Array.from(files).filter((f) => f instanceof File);
        if (fileArray.length === 0) return;

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append("idRealisation", reaId);

            // envoyer toutes les images d’un coup
            fileArray.forEach((file) => {
                formData.append("photos[]", file);
            });

            const res = await fetch(`${apiUrl}/api/updateProfil/addPhotosRealisationPrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const json = await res.json().catch(() => ({}));

            if (!res.ok || !json.success) {
                throw new Error(json.error || json.message || "Erreur lors de l’envoi des photos.");
            }

            // rafraîchir les réalisations
            refreshRealisations();

        } catch (err) {
            console.error("Erreur upload photos :", err);
            alert(err.message || "Erreur lors de l'envoi des photos.");
        } finally {
            setUploading(false);
        }
    };


    const deletePhoto = async (reaId, photoId) => {
        const formData = new FormData();
        formData.append("idRealisation", reaId);
        formData.append("idPhotoRealisation", photoId);

        try {
            const res = await fetch(`${apiUrl}/api/updateProfil/deletePhotoRealisationPrestataire`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });
            const data = await res.json();
            if (data.success) refreshRealisations();
            else alert(data.error || "Erreur lors de la suppression de la photo.");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la suppression de la photo.");
        }
    };

    /* ------------------ NAVIGATION -------------------- */
    const prev = () => setIndex((i) => (i > 0 ? i - 1 : i));
    const next = () => setIndex((i) => (i < realisations.length - 1 ? i + 1 : i));

    if (!realisations || realisations.length === 0) {
        return (
            <div style={{ marginTop: "20px" }}>
                <button className="btn-primary" onClick={() => setShowFormRea(true)}>
                    Ajouter une réalisation
                </button>
                {showFormAddRea && (
                    <ModalFormAddRealisationPresta
                        onUpdate={refreshRealisations}
                        onClose={() => setShowFormRea(false)}
                    />
                )}
            </div>
        );
    }

    const currentRea = realisations[index];

    return (
        <div style={{ maxWidth: "650px", margin: "0 auto", marginTop: "30px" }}>
            <button className="btn-primary mb-4" onClick={() => setShowFormRea(true)}>
                Ajouter une réalisation
            </button>

            <div style={cardStyle}>
                <button
                    onClick={() => deleteRealisation(currentRea.idRealisationPrestataire)}
                    style={deleteReaBtn}
                    title="Supprimer la réalisation"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <h2>{currentRea.titreRealisation}</h2>
                    <FontAwesomeIcon
                        icon={faPen}
                        style={editIconStyle}
                        onClick={() => setEditingRea(currentRea)}
                    />
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <p>{currentRea.descriptionRealisation}</p>
                    <FontAwesomeIcon
                        icon={faPen}
                        style={editIconStyle}
                        onClick={() => setEditingRea(currentRea)}
                    />
                </div>

                <div style={photoContainerStyle}>
                    {selectedImages.map((photo, i) => (
                        <PhotoItem
                            key={i}
                            photo={photo}
                            onDelete={() => deletePhoto(currentRea.idRealisationPrestataire, photo.idPhotoRealisation)}
                        />
                    ))}
                </div>


                {/* INPUT MULTIPLE: envoie tous les fichiers sélectionnés directement à l'API */}
                <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={(e) => {
                            const files = e.target.files;
                            if (!files) return;
                            addPhotos(currentRea.idRealisationPrestataire, files);
                            // vider le input pour permettre re-sélection mêmes fichiers si besoin
                            e.target.value = "";
                        }}
                    />
                    {uploading && <span>Upload en cours…</span>}
                </div>
            </div>

            {realisations.length > 1 && (
                <div style={navContainerStyle}>
                    <button disabled={index === 0} onClick={prev} style={navBtnStyle}>
                        ◀ Précédent
                    </button>
                    <span>
                        {index + 1} / {realisations.length}
                    </span>
                    <button disabled={index === realisations.length - 1} onClick={next} style={navBtnStyle}>
                        Suivant ▶
                    </button>
                </div>
            )}

            {showFormAddRea && (
                <ModalFormAddRealisationPresta
                    onUpdate={refreshRealisations}
                    onClose={() => setShowFormRea(false)}
                />
            )}
            {editingRea && (
                <EditOverlay
                    titreInitial={editingRea.titreRealisation}
                    descriptionInitial={editingRea.descriptionRealisation}
                    onClose={() => setEditingRea(null)}
                    onSave={(titre, description) => {
                        updateRealisationField(editingRea.idRealisationPrestataire, titre, description);
                        setEditingRea(null);
                    }}
                />
            )}
        </div>
    );
};

export default GestionRealisationsPresta;

/* --- Styles --- */
const cardStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 3px 15px rgba(0,0,0,0.15)",
    marginBottom: "20px",
    position: "relative",
};

const photoContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "10px",
};

const photoItemStyle = {
    width: "120px",
    height: "120px",
    borderRadius: "8px",
    objectFit: "cover",
};

const photoWrapperStyle = {
    position: "relative",
    width: "120px",
    height: "120px",
};

const deletePhotoBtn = {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    background: "red",
    border: "none",
    color: "white",
    borderRadius: "50%",
    width: "22px",
    height: "22px",
    cursor: "pointer",
};

const deleteReaBtn = {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "rgba(255,0,0,0.85)",
    border: "none",
    color: "white",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    fontSize: "17px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};

const editIconStyle = {
    cursor: "pointer",
    color: "#007bff",
};

const navContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    marginTop: "15px",
};

const navBtnStyle = {
    padding: "6px 12px",
    borderRadius: "6px",
    border: "none",
    background: "#007bff",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
};
